export default __webpack_public_path__ + "static/hw_ff_dht11-43c7c5f3f20e8b54cd85955e2260cb6c.png";